import { Button, Empty, Modal, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAuditLogs } from '../../redux/actions/JournalAuditActions';
import dayjs from 'dayjs';
import BarreRecherche from '../../components/buttons/BarreRecherche';

function Journal() {
  const dispatch = useDispatch();
  const limit = 20;
  const [page, setPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState({});

  const data = useSelector((state) => state.auditLogs);
  const journal = data.auditLogs?.logs || [];
  const totalItem = data.auditLogs?.total || 0;

  useEffect(() => {
    dispatch(fetchAuditLogs(page, limit));
  }, [page, limit, dispatch]);

  const renderValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return (
        <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
          {JSON.stringify(value, null, 2)}
        </pre>
      );
    }
    return value?.toString();
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Détails",
      dataIndex: "details",
      render: (text) => {
        let detailParsed;
        try {
          detailParsed = typeof text === 'string' ? JSON.parse(text) : text;
        } catch {
          return <span>Erreur de format</span>;
        }

        const body = detailParsed?.body;

        if (!body || Object.keys(body).length === 0) {
          return (
            <Tooltip title="Aucune information disponible" color="#43CE0C">
              <Button type="link" style={{ background: "#43CE0C", color: '#fff' }}>
                Voir détail
              </Button>
            </Tooltip>
          );
        }

        return (
          <Button
            style={{ background: "#43CE0C", color: "#fff" }}
            onClick={() => {
              setDetail(body);
              setVisible(true);
            }}
          >
            Voir détail
          </Button>
        );
      },
    },
    {
      title: "IP",
      dataIndex: "ip",
    },
    {
      title: "Date de création",
      dataIndex: "createdAt",
      render: (text) => (
        <p>{dayjs(text).format("DD-MM-YYYY HH:mm:ss")}</p>
      ),
    },
    {
      title: "Date de mise à jour",
      dataIndex: "updatedAt",
      render: (text) => (
        <p>{dayjs(text).format("DD-MM-YYYY HH:mm:ss")}</p>
      ),
    },
  ];
const [searchValue, setSearchValue] = useState('');
        const filtrData = journal?.filter(item =>
          item?.action.toLowerCase().includes(searchValue.toLowerCase()) ||
          item?.ip.toLowerCase().includes(searchValue.toLowerCase()) ||
          dayjs(item?.createdAt).format("DD-MM-YYYY HH:mm:ss").toLowerCase().includes(searchValue.toLowerCase()) ||
          dayjs(item?.updatedAt).format("DD-MM-YYYY HH:mm:ss").toLowerCase().includes(searchValue.toLowerCase())
          );
 

  return (
    <div>
      <div style={{ width:"100%", marginBottom:"2%", display: "flex", justifyContent: "flex-end" }}> 
        <BarreRecherche type="text" 
                    //  value={searchValue} 
                    onChange={(e) => setSearchValue(e.target.value)} 
                    allowClear  /></div>
      <Table
        columns={columns}
        dataSource={filtrData}
        rowKey={(record, index) => record.id || index}
        pagination={{
          current: page,
          pageSize: limit,
          total: totalItem,
          onChange: (newPage) => setPage(newPage),
        }}
      locale={{ emptyText: <Empty description="Aucune donnée disponible" /> }}
      />

      <Modal
        title="Détails"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={600}
      >
        {Object.entries(detail).map(([key, value]) => (
          <p key={key}>
            <strong>{key}:</strong> {renderValue(value)}
          </p>
        ))}
      </Modal>
    </div>
  );
}

export default Journal;
